const WatchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00065 1.33325C4.33398 1.33325 1.33398 4.33325 1.33398 7.99992C1.33398 11.6666 4.33398 14.6666 8.00065 14.6666C11.6673 14.6666 14.6673 11.6666 14.6673 7.99992C14.6673 4.33325 11.6673 1.33325 8.00065 1.33325ZM10.3673 10.5333L7.64732 8.85992C7.44732 8.73992 7.32732 8.52659 7.32732 8.29325V5.16659C7.33398 4.89325 7.56065 4.66659 7.83399 4.66659C8.10732 4.66659 8.33399 4.89325 8.33399 5.16659V8.13325L10.894 9.67325C11.134 9.81992 11.214 10.1333 11.0673 10.3733C10.9207 10.6066 10.6073 10.6799 10.3673 10.5333Z"
      fill="#161015"
    />
  </svg>
)

export default WatchIcon
